import { useGetPayrollSettingsMap } from '~/services/payroll';

export const usePayrollSettings = () => {
  const { data: settingsMap, isLoading, error } = useGetPayrollSettingsMap();

  const getSettingValue = (key: string, defaultValue: string = '') => {
    return settingsMap?.[key] || defaultValue;
  };

  const settings = {
    payPeriod: getSettingValue('pay_period', 'weekly'),
    paymentDay: getSettingValue('payment_day', 'Friday'),
    weekStartDay: getSettingValue('week_start_day', 'Sunday'),
    weekEndDay: getSettingValue('week_end_day', 'Saturday'),
    overtimeThreshold: parseFloat(getSettingValue('overtime_threshold', '40')),
    overtimeMultiplier: parseFloat(getSettingValue('overtime_multiplier', '1.5')),
  };

  return {
    settings,
    isLoading,
    error,
    rawSettingsMap: settingsMap,
  };
};
